import ReusableDrawer from "../../common/ReusableDrawer"
import FilterOptions from "./DealerTableFiltering/FilterOptions"
import FilterButtons from "./DealerTableFiltering/FilterButtons"
import useStore from "../../../store"
import { colors } from "../../../utilities/colors"

export default function DealerTableFilterDrawer({isOpen, onClose, setSearchTerm, setFilterParams, filterParams}) {
  const userLocation = useStore((state) => state.userLocation)
  const setDealerFilterAttribute = useStore((state) => state.setDealerFilterAttribute)
  const setDealerFilterDirection = useStore((state) => state.setDealerFilterDirection)
  const nearbyDealersFetching = useStore((state) => state.nearbyDealersFetching)
  const dealerResultsCount = useStore((state) => state.dealerPaginationData.dealerResultsCount)
  const setDealersPage = useStore((state) => state.setDealersPage)
  const setErrMessage = useStore((state) => state.setErrMessage)

  const handleFilterByRadius = (item) => {
    if (!item.id) {
      return
    }

    if (userLocation?.latitude == null || userLocation?.longitude == null) {
      setErrMessage('Unable to determine your location. Please enable location services and try again.')
      return
    }

    setFilterParams({
      ...filterParams,
      "filter[distance]": item.id,
      "filter[lat]": userLocation.latitude,
      "filter[lng]": userLocation.longitude,
    })
  }

  const handleResetFilter = () => {
    setDealerFilterDirection('')
    setSearchTerm('')
    setFilterParams('')
    setDealerFilterAttribute('default')
    setDealersPage(1)
    onClose()
  }

  return(
    <ReusableDrawer
    isOpen={isOpen}
    onClose={onClose}
    bgColor={colors.deepOcean}
    title="Filter Dealers"
    placement={'end'}
    bodyContent={
      <FilterOptions
        setFilterParams={setFilterParams}
        filterParams={filterParams}
        handleFilterByRadius={handleFilterByRadius}
      />
    }
    footerContent={
      <FilterButtons
        handleResetFilter={handleResetFilter}
        handleSubmit={() => onClose()}
        resultsCount={dealerResultsCount}
        resultsFetching={nearbyDealersFetching}
      />
    }
  />
  )
}